module.exports = "/static/assets/2b2499f31323d7bd8e360c764a838cc6.gif";